var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sw-title-pane-group', 'sw-flexbox', 'sw-flexbox--column']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }